/**
 * @Author: Nenad Brcic
 * @Date: 31.08.16
 * @Email: neno@neno.ch
 */

import React, { PropTypes } from 'react';
import styles from './caption.scss';
import CSSModules from 'react-css-modules';

const activeStyle = {
    position: 'relative',
    top: '0',
    left: '0',
    opacity: '1',
};

const Caption = ({ media, activeSlide, slideIndex }) => (
    <div styleName="caption" style={ activeSlide === slideIndex ? activeStyle : {}}>
        { !!media.MulCaption && <p styleName="text">{ media.MulCaption }</p> }
        { !!media.MulCreditline && <p styleName="text">{ media.MulCreditline }</p> }
    </div>
);

Caption.propTypes = {
    media: PropTypes.object.isRequired,
    activeSlide: PropTypes.number,
    slideIndex: PropTypes.number,
};

export default CSSModules(Caption, styles);


// WEBPACK FOOTER //
// ./app/components/Object/Slider/Caption/Caption.jsx